<template>

  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="bg-white p-1 d-flex justify-content-between align-items-center">
      <h5 class="card-title fw-bold mb-0">Documents</h5>
      <button class="btn-close" @click="$emit('close')" aria-label="Close"></button>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="form-group mb-3">
          <label for="qwilr-definition" class="form-label fs-9">Qwilr Definition </label>
          <select 
              class="form-select shadow-none fw-semibold rounded-0 form-xs"
              v-model="selectedDefinitionId" @change="fetchQwilrElements"
              >
              <option disabled value="">Select definition</option>
              <option 
                  v-for="(definition, index) in qwilrDefinitions" 
                  :key="index" 
                  :value="definition.id"
              >
              {{ definition.qwilrDefinitionName }}
              </option>
          </select>
      </div>

      <div class="form-group mb-2">
        <label for="qwilr-source-type" class="form-label fs-9">Qwilr Source Type :</label>
        <div class="row">
          <div class="col-3"><label class="form-label fs-9">
            <input type="radio" v-model="selectedQwilrSourceType" value=1 @change="qwilrSourceTypeHandleChange"/>
            Block
          </label></div>
          <div class="col-9"><label class="form-label fs-9">
            <input type="radio" v-model="selectedQwilrSourceType" value=2 @change="qwilrSourceTypeHandleChange"/>
            Template
          </label></div>
        </div>
      </div>

      <div class="form-group mb-2">
        <label for="qwilr-element" class="form-label fs-9">Qwilr {{this.qwilrElementTitle}} </label>
        <select 
            class="form-select shadow-none fw-semibold rounded-0 form-xs"
            v-model="selectedElementId" :disabled="qwilrElementOptionDisable" 
            >
            <option value="">Select {{this.qwilrElementTitle}}</option>
            <option 
                v-for="(element, index) in qwilrElements" 
                :key="index" 
                :value="element.id"
            >
            {{ element.title }}
            </option>
        </select>
      </div>

      <div class="form-group mb-2">
        <label for="document-title" class="form-label fs-9">Document Title</label>
        <input
          type="text"
          id="document-title"
          class="form-control form-xs"
          v-model="documentTitle"
      />
      </div>

      <div class="form-group mb-2">
        <label for="document-title" class="form-label fs-9">Document Tags</label>
        <input
          type="text"
          id="document-tags"
          class="form-control form-xs"
          v-model="documentTags"
      />
      </div>

      <h5 class="mb-5">Parameters</h5>
      
      <div class="form-group mb-2" v-for="keyField in keyFields" :key="keyField.id">
        <label class="form-label fs-9">{{ keyField.fieldName }}</label>

        <input
          v-if="keyField.fieldType === FieldType.Text"
          type="text"
          class="form-control form-xs"
          v-model="keyField.fieldValue"
          @change="getQwilrParameterValue()"
        />

        <select
          v-else-if="keyField.fieldType === FieldType.Query"
          class="form-control form-xs"
          v-model="keyField.fieldValue"
        >
          <option value="">Choose...</option>
          <option v-for="option in keyField.options" :key="option.value" :value="option.columnId">
            {{ option.columnValue }}
          </option>
        </select>
      </div>

        
      <div class="mt-4 mb-4">
        <button :disabled="qwilrIntegrationInfo == null || !qwilrIntegrationInfo.isConnected || isBusy" class="btn btn-primary" @click="generateDocument">
          
          <div v-if="isBusy">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>

              Loading...
          </div>
          <div v-else>
            Generate
          </div>
        </button>
        <br><span v-if="qwilrIntegrationInfo == null || !qwilrIntegrationInfo.isConnected">Please enable Qwilr Integration.</span>
      </div>
        
      <div class="table-responsive" style="overflow: visible;">
            <table class="table align-middle mb-0">
              <colgroup>
                <col style="width: 39%;">
                <col style="width: 39%;">
                <col style="width: 20%;">
                <col style="width: 2%;">
              </colgroup>
              <thead>
                <tr>
                  <th  scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-12 pt-0 ps-0">
                    Document Title
                  </th>
                  <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-12 pt-0 ps-0">
                    Created At
                  </th>
                  <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-12 pt-0 ps-0 d-flex justify-content-center align-items-center">
                    Actions
                  </th>
                  <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-12 pt-0 text-end pe-0">
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="qwilrPage in qwilrPages" :key="qwilrPage.id">
                  <th class="shadow-none title lh-1 fw-medium fs-md-14 fs-lg-15 ps-0">
                    {{ qwilrPage.pageTitle }}
                  </th>
                  <th class="shadow-none title lh-1 fw-medium fs-md-14 fs-lg-15 ps-0">
                    {{ formatDateTime(qwilrPage.createdAt) }}
                  </th>
                  <th class="shadow-none title lh-1 fw-medium fs-md-14 fs-lg-15 ps-0 d-flex justify-content-center align-items-center">
                    <a style="margin-right: 10px;" :href="qwilrPage.qwilrPublicUrl" target="_blank" class="text-decoration-none text-primary">
                      <i class="flaticon-view"></i>
                    </a>
                    <a :href="qwilrPage.qwilrPDFUrl" target="_blank" class="text-decoration-none text-primary">
                      <i class="flaticon-download"></i>
                    </a>
                  </th>
                  <td class="shadow-none lh-1 fw-medium text-end pe-0">
                    <div class="dropdown">
                      <button class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                        <i class="flaticon-dots"></i>
                      </button>
                      <ul class="dropdown-menu">
                        <li>
                          <a
                            class="dropdown-item d-flex align-items-center"
                            href="#" @click.prevent="deletePage(qwilrPage.id)"
                            ><i
                              class="flaticon-delete lh-1 me-8 position-relative top-1"
                            ></i>
                            Delete</a
                          >
                        </li>
                      </ul>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
      </div>
      <!-- <div class="pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center">
        <p class="mb-0 text-paragraph">
          Showing <span class="fw-bold">{{ qwilrPages.length }}</span> out of
          <span class="fw-bold">{{ totalQwilrPages }}</span> results
        </p>
        <nav class="mt-15 mt-md-0">
          <ul class="pagination mb-0">
            <li class="page-item" :class="{ disabled: pageIndex === 1 }">
              <a class="page-link" href="#" aria-label="Previous" @click.prevent="changePage(pageIndex - 1)">
                <i class="flaticon-chevron-1"></i>
              </a>
            </li>
            <li class="page-item" v-for="page in totalQwilrPages" :key="page" :class="{ active: page === pageIndex }">
              <a class="page-link" href="#" @click.prevent="changePage(page)">{{ page }}</a>
            </li>
            <li class="page-item" :class="{ disabled: pageIndex === totalQwilrPages }">
              <a class="page-link" href="#" aria-label="Next" @click.prevent="changePage(pageIndex + 1)">
                <i class="flaticon-chevron"></i>
              </a>
            </li>
          </ul>
        </nav>
      </div> -->
    </div>
    
  </div>
    
</template>
  
  <script>
  import { GetQwilrDefinitionElements, CreateQwilrPage, GetQwilrParameterValue } from '@/core/services/entities/qwilr.service'
  import { useToast } from 'vue-toastification'
  import { GetQwilrDefinitions, GetQwilrPages, DeleteQwilrPage, GetQwilrDefinitionKeyFieldsQueryModel } from '@/core/services/entities/qwilr.service'
  import { GetQwilrIntegrationInfo } from '@/core/services/entities/integrations.service'
  import Swal from 'sweetalert2';
  import { FieldType} from "@/core/constant/QueryFieldType";

  export default{
    name:"GenerateDocument",
    props:{
        generateDocumentParameters:{
            type:Object,
            required:true
        }
    },
    data(){
        return{
            qwilrDefinitions:[],
            qwilrElements:[],
            selectedQwilrSourceType:0,
            qwilrElementTitle:'Block',
            qwilrElementOptionDisable:true,
            qwilrPages: [], 
            totalQwilrPages:0,
            pageSize: 10, 
            pageIndex: 1,
            documentTags:"",
            qwilrIntegrationInfo: null,
            keyFields:[],
            FieldType,
            allParameters: {},
            isBusy: false
        }
    },
    methods:{
        async generateDocument(){
            this.isBusy = true;
            const toast = useToast();
            
            setTimeout(async () => {
              if(!this.selectedElementId){
                if(this.selectedQwilrSourceType==1){
                  toast.error('Block is required!', {
                          timeout: 2000
                          })
                  this.isBusy = false;        
                }

                if(this.selectedQwilrSourceType==2){
                  toast.error('Template is required!', {
                          timeout: 2000
                          })
                  this.isBusy = false;           
                }
              
                return;          
              }
            
              this.keyFields
                .forEach(item => {
                  this.allParameters[item.fieldName] = item.fieldValue.toString();
                });  
              
              if (Object.values(this.allParameters).some(value => value === null || value === undefined || value === "")) {
                toast.error(`Some parameters are empty. Please fill in all required parameters.`, {timeout: 2000,});
                this.isBusy = false;
                return;
              }

              const payload = { 
                qwilrDefinitionId:this.selectedDefinitionId,
                qwilrDefinitionElementId:this.selectedElementId,
                pageTitle:this.documentTitle,
                tags:this.documentTags,
                queryParameters:this.allParameters,
                generatedTag: this.documentTag
              };

              await CreateQwilrPage(payload)
                      .then(response => {
                      if (response.status === 200) {
                          toast.success('Document generated successfully!', {
                          timeout: 2000
                          })
                          this.isBusy = false;
                          this.fetchQwilrPages();
                      }
                      })
                      .catch(ex => {
                          this.isBusy = false;
                          const errorMessage = ex.response?.data || ex.message || "An unknown error occurred";
                          console.log(ex);
                          toast.error(`Failed to generate document : ${errorMessage}`, {timeout: 2000,});
                      })
            }, 1000);

        },
        async fetchQwilrDefinitions() {
          let data = await GetQwilrDefinitions();
          if(data)
          {
            this.qwilrDefinitions = data.qwilrDefinitions;
          }
        },
        async fetchQwilrIntegrationInfo() {
          let data = await GetQwilrIntegrationInfo();
          if(data)
          {
            this.qwilrIntegrationInfo = data.integration;
          }
        },
        async qwilrSourceTypeHandleChange(){
          if(this.selectedQwilrSourceType==1){
            this.qwilrElementTitle="Block"
          }else{
            this.qwilrElementTitle="Template"
          }

          this.fetchQwilrElements();
        },
        async fetchQwilrElements() {
          if(this.selectedDefinitionId){
            this.qwilrElementOptionDisable=false
          }
          
          let isBlock=true;
          if(this.selectedQwilrSourceType==2){
            isBlock=false;
          }

          let data = await GetQwilrDefinitionElements(this.selectedDefinitionId, isBlock);
          if(data)
          {
            this.qwilrElements = data.qwilrDefinitionElements;
          }

          let keyFieldsData = await GetQwilrDefinitionKeyFieldsQueryModel(this.selectedDefinitionId);
          if(keyFieldsData)
          {
            this.keyFields = keyFieldsData.qwilrDefinitionKeyFieldsQueryModel;
            // this.keyFields=this.keyFields.sort((a, b) => (a.fieldType === FieldType.Query ? 1 : -1));
          }
          
          this.getKeyInitialValue();
          this.getQwilrParameterValue();
          
        },
        async fetchQwilrPages() {
            let data = await GetQwilrPages(this.documentTag,this.pageSize);
            if(data)
            {
              this.qwilrPages = data.qwilrPages;
              this.totalQwilrPages = data.qwilrPages.length;
            }

        },
        formatDateTime(date){
          const options = { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' };
          return new Date(date).toLocaleDateString('en-GB', options).replace(',', '');
        },
        changePage(page) {
          if (page > 0 && page <= this.totalQwilrPages) {
            this.pageIndex = page;
            // this.fetchQwilrPages();
          }
        },
        async getQwilrParameterValue() {
          for (const field of this.keyFields.filter(f => f.fieldType === this.FieldType.Query)) {
            
            const matches = field.query.match(/@\w+/g) || [];
            // const cleanedMatches = matches.map(match => match.substring(1));
            const fieldParams = [...matches]; 

            let providedParams = {};

            this.keyFields
              .filter(item => 
                item.fieldType === this.FieldType.Text &&
                item.fieldValue != null &&
                item.fieldValue !== ""  
              )
              .forEach(item => {
                providedParams[item.fieldName] = item.fieldValue.toString();
              });

            const missingParams = fieldParams.filter(param => !(param in providedParams));

            if (missingParams.length > 0) {
              
              return;
            }

            const payload = { 
              fieldId: field.id,
              parameters: providedParams
            };

            try {
              let data = await GetQwilrParameterValue(payload);
              if (data) {
                field.options = data.parameterValues;
              }
            } catch (error) {
              console.error("Error fetching Qwilr parameter value:", error);
            }


          }
        },
        async getKeyInitialValue(){
          this.keyFields.forEach(field => {
          if (this.generateDocumentParameters) {
            const projectKeys = Object.keys(this.generateDocumentParameters).map(key => key.toLowerCase());
            
            if (projectKeys.includes(field.fieldName.toLowerCase().substring(1))) {
              const matchingKey = Object.keys(this.generateDocumentParameters).find(
                key => key.toLowerCase() === field.fieldName.toLowerCase().substring(1)
              );
              field.fieldValue = this.generateDocumentParameters[matchingKey];
            }
          }
        });

          
        },
        async deletePage(pageId) {
        const toast = useToast();

        // Show confirmation dialog using SweetAlert2
        Swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!',
          target: document.body
        }).then(async (result) => {  
          if (result.isConfirmed) {
            try {
              const payload = { id: pageId };
              let response = await DeleteQwilrPage(payload);  
              if (response.status === 200) {
                toast.success('Page deleted successfully!', {
                  timeout: 2000,
                });
                this.fetchQwilrPages();
              }
            } catch (ex) {
              const errorMessage = ex.response?.data || ex.message || "An unknown error occurred";
              console.log(errorMessage);
              toast.error(`Failed to delete page: ${errorMessage}`, {
                timeout: 2000,
              });
            }
          } else {
            toast.info('Page deletion canceled.', { timeout: 2000 });
          }
        });

      }
    },
    created() {
      this.fetchQwilrDefinitions();
      this.fetchQwilrPages();
      this.selectedQwilrSourceType=1;
      this.qwilrElementOptionDisable=true
      this.fetchQwilrIntegrationInfo();
    },
    computed:{
      documentTag() {
        return `PROJECTLIST__LEADID_${this.generateDocumentParameters.leadID}`;
      }
    }
  }
 </script>
  
  <style scoped>
  
  .form-group {
    margin-bottom: 1rem;
  }
  
  .form-label {
    display: block;
    margin-bottom: 0.5rem;
  }
  
  .form-control {
    width: 100%;
    padding: 0.5rem;
    margin-bottom: 0.5rem;
  }
  
  .form-buttons {
    display: flex;
    justify-content: space-between;
    margin-top: 1rem;
  }
  
  .btn {
    padding: 0.5rem 1rem;
  }
  
  .btn-secondary {
    background-color: #6c757d;
    color: #fff;
  }
  
  .btn-secondary:hover {
    background-color: #5a6268;
  }

  .form-xs {
    padding: 4px 6px;
    font-size: 12px;
    height: 30px;
  }

  .swal2-container {
    z-index: 9999 !important;
  }

  .wrap-text {
    white-space: normal;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  </style>
  